import { Purchases } from '@revenuecat/purchases-capacitor';

class RevenueCatService {
  constructor() {
    this.isInitialized = false;
  }

  async initialize() {
    if (this.isInitialized) return;

    try {
      // Configure RevenueCat with your API key
      await Purchases.configure({
        apiKey: import.meta.env.VITE_REVENUECAT_API_KEY,
        appUserID: null, // Will be set when user logs in
      });
      
      this.isInitialized = true;
      console.log('RevenueCat initialized successfully');
    } catch (error) {
      console.error('Failed to initialize RevenueCat:', error);
      throw error;
    }
  }

  async setUser(userId) {
    try {
      await Purchases.logIn(userId);
      console.log('RevenueCat user set:', userId);
    } catch (error) {
      console.error('Failed to set RevenueCat user:', error);
      throw error;
    }
  }

  async getOfferings() {
    try {
      const offerings = await Purchases.getOfferings();
      return offerings;
    } catch (error) {
      console.error('Failed to get offerings:', error);
      throw error;
    }
  }

  async purchasePackage(packageToPurchase) {
    try {
      const result = await Purchases.purchasePackage(packageToPurchase);
      return result;
    } catch (error) {
      console.error('Failed to purchase package:', error);
      throw error;
    }
  }

  async restorePurchases() {
    try {
      const result = await Purchases.restorePurchases();
      return result;
    } catch (error) {
      console.error('Failed to restore purchases:', error);
      throw error;
    }
  }

  async getCustomerInfo() {
    try {
      const customerInfo = await Purchases.getCustomerInfo();
      return customerInfo;
    } catch (error) {
      console.error('Failed to get customer info:', error);
      throw error;
    }
  }

  async logOut() {
    try {
      await Purchases.logOut();
      console.log('RevenueCat user logged out');
    } catch (error) {
      console.error('Failed to log out RevenueCat user:', error);
      throw error;
    }
  }
}

export default new RevenueCatService();
